export const ADMIN_ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  STAFF: 'staff',
};

export const isSuperAdmin = (role) => role === ADMIN_ROLES.SUPERADMIN;
export const isStaff = (role) => role === ADMIN_ROLES.STAFF;
